export enum XrmFormType {
    Undefined = 0,
    Create = 1,
    Update = 2,
    Disabled = 4,
    Dialog = 12
}